module.exports = __webpack_public_path__ + "img/screw-0.01bd0911.png";